import { useLocation } from 'react-router-dom';
import { parseGamePath, type BoxRoute } from '@src/routing/routes';

/**
 * The box the current route is about. Read from the router location so a
 * client-side move from one key to another does not keep the previous parse.
 */
export function useBoxRoute(): BoxRoute | null {
  const { pathname } = useLocation();
  return parseGamePath(pathname, typeof window !== 'undefined' ? window.__ssBoxKey : undefined);
}
